export default __webpack_public_path__ + "img/960aa06ea30d473931218f1c25ba73bf.svg";